import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { WalletType } from '../../@types/api';
import { WALLET_TYPE_OPTIONS } from '../../constants';
import usePermissions from '../../hooks/usePermissions';
import { StyleObj } from '../../@types';

type WalletTypeSelectProps = {
  value: WalletType | null;
  onChange: (e: SelectChangeEvent<WalletType | null>) => void;
};

const styles: StyleObj = {
  walletTypeSelect: (theme) => ({
    width: 140,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  }),
};

const WalletTypeSelect = ({ value, onChange }: WalletTypeSelectProps) => {
  const { hasPermission } = usePermissions();
  const hasAdminCredentials = hasPermission('defaultAdminRole');

  return (
    <FormControl sx={styles.walletTypeSelect}>
      <InputLabel id='wallet-type-select-label'>Wallet Type</InputLabel>
      <Select label='Wallet Type' value={value} onChange={onChange} sx={styles.walletTypeSelect}>
        {WALLET_TYPE_OPTIONS(hasAdminCredentials).map((option) => (
          <MenuItem
            key={option.id}
            value={option.id}
            onClick={(e) => {
              if (option.id === value) {
                onChange({ target: { value: null } } as SelectChangeEvent<WalletType | null>);
              }
            }}
          >
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default WalletTypeSelect;
